import { API } from 'aws-amplify'

import * as actionTypes from './actionTypes';

const basePath = '/organizations';
const apiName = 'organizations';
const actions = {
  createOrg: async ({ commit }, payload) => {
    const { vm, org } = payload;
    const opts = {
      body: [org],
    };
    commit(actionTypes.CREATE_ORG_START);
    try {
      const res = await API.post(apiName, basePath, opts);
      console.log('Create ORG res: ', res);
      commit(actionTypes.CREATE_ORG_SUCCESS, res);
      vm.$bvToast.toast(`${org.name} was created successfully!`, {
        autoHideDelay: 5000,
        appendToast: true,
        toaster: 'b-toaster-top-center',
        headerClass: 'b-toaster-no-line'
      });
      vm.$store.dispatch('listOrgs');
    } catch (err) {
      console.log('Error creating org: ', err.response);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.CREATE_ORG_FAIL, errorMsg);
    }
  },
  listOrgs: async ({ commit }) => {
    commit(actionTypes.LIST_ORGS_START);
    const path = `${basePath}/all`;
    try {
      const res = await API.get(apiName, path, {});
      console.log('List Orgs res: ', res);
      commit(actionTypes.LIST_ORGS_SUCCESS, res);
    } catch (err) {
      console.log('List Orgs Error: ', err);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.LIST_ORGS_FAIL, errorMsg);
    }
  },
  updateOrg: async ({ commit }, payload) => {
    commit(actionTypes.UPDATE_ORG_START);
    const { vm, org } = payload;
    const opts = {
      body: {
        isEnabled: org.isEnabled,
      },
    };
    const path = `${basePath}/${org.org.id}`;
    try {
      const res = await API.put(apiName, path, opts);
      console.log('Update ORG - res: ', res);
      commit(actionTypes.UPDATE_ORG_SUCCESS, res);
      vm.$store.dispatch('listOrgs');
    } catch (err) {
      console.log('Organization Update Error: ', err);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.UPDATE_ORG_FAIL, errorMsg);
    }
  },
  deleteOrg: async ({ commit }, payload) => {
    commit(actionTypes.DELETE_ORG_START);
    const path = `${basePath}/${payload}`;
    const opts = {};
    try {
      const res = await API.del(apiName, path, opts);
      console.log('Delete Org  - res: ', res);
      commit(actionTypes.DELETE_ORG_SUCCESS, res);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.DELETE_ORG_FAIL, errorMsg);
    }
  },
  getOrg: async ({ commit }, payload) => {
    commit(actionTypes.GET_ORG_START);
    const path = `${basePath}/${payload}`;
    const opts = {};
    try {
      const res = await API.get(apiName, path, opts);
      console.log('Get ORG - res: ', res);
      commit(actionTypes.GET_ORG_SUCCESS, res);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.GET_ORG_FAIL, errorMsg);
    }
  },
  setOrgToUpdate: ({ commit }, payload) => {
    commit(actionTypes.SET_ORG_TO_UPDATE, payload);
  },
  clearOrgState: ({ commit }) => {
    commit(actionTypes.CLEAR_ORG_UPDATE_STATE);
  }
};

export default actions;
